<template>
  <footer class="page-footer_pfr" :class="{ [curTheme]: true }">
    <div class="pfr_container">

      <div class="pfr_el pfr_el--left">
        <div class="pfr_line-one">
          <span class="pfr_link" @click="$router.push({ path: '/about-project' })">
            О проекте</span>
          <span class="pfr_link" @click="$router.push({ path: '/user-agreement' })">
            Пользовательское соглашение</span>
        </div>
        <span class="pfr_dimmed">&copy; 2017-{{ (new Date()).getFullYear() }},</span>
        Сибирский федеральный&nbsp;университет
      </div>

      <div class="pfr_el pfr_el--right">
        <div class="pfr_line-one">
          <template v-if="$store.getters['user/isAuthenticated']">
            <span class="pfr_enter-as">Вы вошли как</span>
            <span
              class="pfr_link pfr_surnamename"
              @click="$router.push({ path: '/user/objects' })">
                {{ userFio }}</span>
            <span
              class="pfr_link"
              @click="$store.dispatch('user/logout')">
                Выйти</span>
          </template>
          <template v-else>
            <span
              class="pfr_link"
              style="display:inline-block;margin-right:10px;"
              @click="$router.push({ path: '/user/authenticate' })">
              Войти</span>
            <span
              class="pfr_link"
              style="display:inline-block;margin-right:10px;"
              @click="$router.push({ path: '/user/register' })">
              Зарегистрироваться</span>
          </template>
        </div>
        <div class="pfr_block">
          <i class="el-icon-message"></i>
          <a href="mailto:ipuniversity@sfu-kras.ru" class="pfr_dimmed">
            ipuniversity@sfu-kras.ru</a>
        </div>
        <div class="pfr_block">
          <i class="el-icon-phone"></i> <span class="pfr_dimmed">
            +7 (391) 291-27-46</span>
        </div>
        <div class="pfr_block">
          <i class="pfr_icon pfr_icon--f"></i>
          <a href="https://www.facebook.com/groups/IPUPlatform/"
            target="_blank" class="pfr_dimmed">Мы в Facebook</a>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
import axios from 'axios';

export default {

  data() {
    return {
      userData: null,
    };
  },

  computed: {

    userFio() {
      let sn = '';
      if (this.userData) {
        sn = `${this.userData.Surname} ${this.userData.Name}`;
      }
      return sn;
    },

  },

  created() {
    const userId = this.$store.getters['user/getUserId'];
    if (userId) {
      axios.get(`users/${userId}`).then((r) => {
        this.userData = r.data;
      }).catch(() => {});
    }
  },

};
</script>

<style lang="scss">
@import '../styles/common/main';

html.html_page-form {
  .page-footer_pfr .pfr_container {
    border: none;
  }
}

.page-footer_pfr {
  position: absolute;
  bottom: 0;
  width: 100%;
  .pfr_enter-as {
    display: inline-block;
    margin-bottom: 5px;
    opacity: .5;
  }
  .pfr_surnamename {
    display: inline-block;
    margin-right: 20px;
  }
  .pfr_container {
    border-top: 1px solid;
    padding: 30px;
    @include clearfix;
    max-width: 1940px;
    margin: 0 auto;
  }
  .pfr_el {
    display: block;
  }
  .pfr_el--left {
    pfr_link {

    }
  }
  .pfr_el--right {
    float: right;
    .pfr_block {
      margin-left: 15px;
    }
    .pfr_line-one {
      padding-left: 14px;
    }
  }
  a.pfr_dimmed {
    @include transition;
  }
  .pfr_line-one {
    display: block;
    margin-bottom: 15px;
    .pfr_link {
      margin-right: 20px;
    }
  }
  .pfr_link {
    cursor: pointer;
    color: #d64b88;
    @include transition;
    line-height: 18px;
    display: inline-block;
    margin-bottom: 5px;
    &:hover {
      @include opacity(.7);
    }
  }
  .pfr_el--left {
    float: left;
  }
  .pfr_block {
    display: inline-block;
    white-space: nowrap;
    i {
      display: inline-block;
      margin-right: 4px;
    }
  }
  .pfr_icon {
    display: inline-block;
    width: 17px;
    height: 17px;
    margin-right: 2px;
    vertical-align: baseline;
    background: 50% 50% no-repeat;
    background-size: contain;
  }
  @media (max-width: 1010px) {
    .pfr_el {
      display: block;
      float: none !important;
      clear: both;
      text-align: center;
      &.pfr_el--left {
        margin-bottom: 15px;
      }
    }
    .pfr_el--right {
      .pfr_line-one {
        padding-left: 0;
      }
    }
  }

  @media (max-width: 601px) {
    .pfr_container {
      width: 250px;
      margin: 0 auto;
      text-align: left;
      .pfr_link {
        margin-top: 10px;
      }
      .pfr_el {
        text-align: left;
        .pfr_block {
          margin-left: 0;
        }
      }
    }
  }

  // Black
  &.theme-b {
    background: $bg-theme-b;

    .pfr_container {
      border-color: #222;
      color: #eee;
    }

    .pfr_dimmed {
      color: #999;
    }

    a.pfr_dimmed {
      color: #ccc;
      &:hover {
        color: #fff;
      }
    }

    .pfr_icon {
      &.pfr_icon--f {
        background-image: url(../../static/grx/icons/f-w.svg);
      }
    }

  }

  // White
  &.theme-w {
    background: $bg-theme-w;

    .pfr_container {
      border-color: #eee;
      color: #444;
    }

    .pfr_dimmed {
      color: #999;
    }

    a.pfr_dimmed {
      color: #444;
      &:hover {
        color: #000;
      }
    }

    .pfr_icon {
      &.pfr_icon--f {
        background-image: url(../../static/grx/icons/f-b.svg);
      }
    }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageFooter.vue